//Grab a client token from the server
export async function getClientToken(braintreeId){

    const url = "/services/braintree/generate-client-token.php" + 
        ((typeof(braintreeId) !== "undefined") ? `?bid=${braintreeId}` : "")

    var response = await fetch(url)
    var data = await response.json()
    
    //handles error messages.. TODO: Make better
    if(data.message){
        alert(data.message)
        return await false
    }
    
    //Return auth token
    return await data.result
}